import type { ComponentType } from 'react';

import { GraduationCap } from 'lucide-react';

import { type GetTeamMemberEditDetailsQuery } from '@graphql/__generated__/graphql';
import { GET_TEAM_MEMBER_EDIT_DETAILS } from '@modules/_shared/components/visibility-drawer/queries/agent-queries';
import AboutSection from '@modules/_shared/components/visibility-drawer/sections/AboutSection';
import DictionarySection, {
  type DictionarySectionCustomProps,
} from '@modules/_shared/components/visibility-drawer/sections/DictionarySection';
import ReviewsSection from '@modules/_shared/components/visibility-drawer/sections/ReviewsSection';
import SocialMediaSection from '@modules/_shared/components/visibility-drawer/sections/SocialMediaSection';
import TransactionsSection from '@modules/_shared/components/visibility-drawer/sections/TransactionsSection';
import type {
  DrawerSectionGroup,
  SectionProps,
} from '@modules/_shared/components/visibility-drawer/types';
import { getAgentDictionaryType } from '@modules/_shared/utils/agentDictionaryFields';
import type { Translate } from '@shared/hooks/locale';

export const getAgentDrawerConfig = (t: Translate) => {
  const sectionGroups: DrawerSectionGroup[] = [
    {
      id: 'identity',
      sections: [
        { id: 'about', component: AboutSection },
        {
          id: 'certifications',
          component: DictionarySection as ComponentType<SectionProps>,
          customProps: {
            title: t('Certifications'),
            dictionaryType: getAgentDictionaryType('certifications'),
            icon: <GraduationCap size={14} />,
          } satisfies DictionarySectionCustomProps,
        },
        {
          id: 'services',
          component: DictionarySection as ComponentType<SectionProps>,
          customProps: {
            title: t('Services'),
            dictionaryType: getAgentDictionaryType('services'),
          } satisfies DictionarySectionCustomProps,
        },
        { id: 'socialMedia', component: SocialMediaSection },
      ],
    },
    {
      id: 'activity',
      sections: [{ id: 'transactions', component: TransactionsSection }],
    },
    {
      id: 'reputation',
      sections: [{ id: 'reviews', component: ReviewsSection }],
    },
  ];

  return {
    entityType: 'user' as const,
    query: GET_TEAM_MEMBER_EDIT_DETAILS,
    extractEntity: (data: GetTeamMemberEditDetailsQuery) =>
      data.users_by_pk ?? null,
    sectionGroups,
  };
};
